import * as Scrivito from "scrivito";

const NewsWidget = Scrivito.provideWidgetClass("NewsWidget", {
  attributes: {
    destination: ["reference", { only: "NewsPage" }],
  },
});

export default NewsWidget;
